<template>
  <div class="hows-mom-bar">
    <img src="@/assets/demo-logo.png" alt="" class="hows-mom logo" />
  </div>
  <main class="main-content">
    <router-view />
  </main>
</template>

<style>
:root {
  --sidebar-width: clamp(340px, 32vw, 448px);
  --layout-gap: 12px;
  --logo-padding-y: 20px;
  --header-height: calc(7vh + 2 * var(--logo-padding-y));
  --prototype-padding-y: 40px;
  --prototype-padding-x: 24px;
  --prototype-web-padding-x: 48px;
  --prototype-max-height: calc(100dvh - 2 * var(--prototype-padding-y) - 48px);
  --sidebar-bg: #f5f5f5;
}

*, *::before, *::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  height: 100%;
  overflow: hidden;
}

html {
  height: 100%;
  overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100dvh;
  max-height: 100dvh;
  overflow: hidden;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.hows-mom-bar {
  width: 100%;
  flex-shrink: 0;
  padding: var(--logo-padding-y) 0;
  display: grid;
  grid-template-columns: var(--sidebar-width) 1fr;
}

.hows-mom-bar > .hows-mom.logo {
  grid-column: 1;
  justify-self: center;
  height: 7vh;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

.main-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

</style>
